export const environment = {
  production: true,
  rutaBase:"https://api.starkengine.com",
  secret_key: "cd2nRttcAGmIiw4WeK5MUUnbowoabW",
  ROLE_ADMIN_ID: 38,
  ROLE_RIESGO_ID: 41, 
  ROLE_OPERACIONES_ID: 39,
  ROLE_AUDIT_ID: 59, 
  LABEL_PROVEEDOR:"Cliente",
  LABEL_PROVEEDORES:"Clientes",
  LABEL_ADQUIRENTE:"Obligado",
  LABEL_ADQUIRENTES:"Obligados",
  LABEL_PROSPECTO:"Prospecto",
  LABEL_PROSPECTOS:"Prospectos",
  LABEL_SIMULADOR:"Simulador",
  LABEL_PROFORMA:"Proforma",
  LABEL_PROFORMAS:"Proformas",
  LABEL_REF_BANCARIAS:"Referencias Bancarias",
  ID_MONEDA_SOLES:640,
  ID_MONEDA_DOLARES:442,
  ID_SERVICIO_FACTORING:565,
  ID_SERVICIO_CONFIRMING:566, 
  ID_GUIA_SOLES:640,
  ID_GUIA_DOLARES:442,
  ID_MONEDA:441,
  ID_BANCO:443,
  ID_PAGO:460,
  ID_TIPO_COMPROBANTEIF:464,
  ID_TIPO_DOC_IDENTIFICACION:469,
  ID_IGV_EXONERADO:473,
  ID_COMPROBANTE_EMITIDO:476,
  ID_COMPROBANTE_CONTA:480,
  ID_ROL_CONTACTO:483,
  ID_CONDICION:489,
  ID_TIPO_CONTACTO:494,
  ID_TIPO_CONFORMIDA:498,
  ID_TIPO_COMPROBANTE:503,
  ID_TIPO_EMISION:506,
  ID_RETENCION_FONDO:509,
  ID_RETENCION:512,
  ID_TIPO_XLS:515,
  ID_TIPO_PLANTILLA:523,
  ID_TIPO_CUENTA:528,
  ID_BANCO_IF:531,
  ID_PARTICIPANTE:534,
  ID_RUT:537,
  ID_TIPO_SOLICITUD:540,
  ID_TIPO_OPERACION:543,
  ID_TIPO_PAGOCPE:546,
  ID_TIPO_OPERACION_NC:549,
  ID_TIPO_OPERACION_ND:560,
  ID_TIPO_SERVICIO:564,
  ID_TIPO_PAGARE:568,
  ID_TIPO_PROCESO:571,
  ID_TIPO_ADJUNTO:575,
  ID_FACTOR_REPRESENTANTE:580,
  ID_FACTOR_DATOS:586,
  ID_FACTOR_BANCO:591,
  ID_TIPO_FACTURACION:627,
  ID_TIPO_DNI:470,
  ID_CARNET:471,
  ID_RUC:472,
  ID_IGV_No_Exonerado:475,
  ID_FACTORING:565,
  ID_CONFIRMING:566,
  ID_DESCUENTO:585,
  ID_DEPOSITO_BANCARIO:461,
  ID_PLANILLA_DE_COLOCACION:462,
  ID_PLANILLA_DE_REMANENTE:463,
  TIPO_PROCESO:{
    CONTRATO_MARCO : 573
  },
  TIPO_PAGARE:{
    COMPLETO:569,
    INCOMPLETO:570
  }
  //rutaBase:"https://api.digitalfactoring.net",
  //secret_key: "cd2nRttcAGmIiw4WeK5MUUnbowoabW",

};
